import React from "react";
import { useI18n } from "../context/I18nContext";
import { AlertTriangle, FileText, Shield } from "lucide-react";

export default function Risks() {
  const { t, lang } = useI18n();
  return (
    <div>
      <section className="section border-b border-slate-200">
        <div className="container-page grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <div className="label-divider mb-6">{t.nav.risks}</div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-slate-900" data-testid="risks-title">
              {t.risks.title}
            </h1>
            <p className="mt-6 text-lg text-slate-600 max-w-2xl">{t.risks.subtitle}</p>
          </div>
          <div className="lg:col-span-4">
            <div className="border-l-2 border-amber-500 bg-amber-50 p-4 flex gap-3">
              <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0" />
              <p className="text-sm text-slate-800 leading-relaxed">{t.warning.short}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-page grid md:grid-cols-2 gap-px bg-slate-200 border border-slate-200">
          {t.risks.items.map((r, i) => (
            <div key={i} className="bg-white p-8" data-testid={`risk-item-${i}`}>
              <div className="font-mono text-xs text-slate-500">R-{String(i + 1).padStart(2, "0")}</div>
              <h3 className="mt-3 font-display text-xl font-semibold text-slate-900">{r.t}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{r.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section bg-slate-50 border-t border-slate-200">
        <div className="container-page">
          <div className="label-divider mb-6">{lang === "fr" ? "Cadre réglementaire" : "Regulatory framework"}</div>
          <div className="grid md:grid-cols-3 gap-6">
            {[
              { i: Shield, t: "AMF", d: lang === "fr" ? "Alignement avec les règles applicables aux offres d'investissement en France." : "Alignment with AMF investment offering rules." },
              { i: FileText, t: "AI Act · DORA", d: lang === "fr" ? "Prise en compte des exigences sur l'IA et la résilience numérique." : "AI Act and DORA digital resilience considered." },
              { i: Shield, t: "RGPD", d: lang === "fr" ? "Données hébergées en UE. Aucun GA par défaut." : "EU-hosted data. No default Google Analytics." },
            ].map((b, i) => {
              const I = b.i;
              return (
                <div key={i} className="bg-white border border-slate-200 rounded-sm p-6" data-testid={`reg-${i}`}>
                  <I className="h-6 w-6 text-slate-900 mb-4" strokeWidth={1.5} />
                  <div className="font-display font-semibold text-slate-900">{b.t}</div>
                  <div className="text-sm text-slate-600 mt-2">{b.d}</div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
